<template>
	<div class="a-flex-rfsc">
        <div class="s-search-label" style="white-space: nowrap;" v-show="label">
			<div>{{label}}</div>
		</div>
		<el-input
			:placeholder="placeholder" :maxlength='maxlength' :disabled='disabled' :value="value" @input="handlerChange">
            <template slot="append" v-if="appendText">{{ appendText }}</template>
            <template slot="prepend" v-if="prependText">{{ prependText }}</template>
		</el-input>
	</div>
	
</template>

<script>
    import util from '@/utils/util'
	export default {
		props:{
			label:{
				type:String
			},
			value:{
				required:true,
				default:''
			},
			placeholder:{
				type:String,
				default:'请输入'
			},
            maxlength: {
                default: 20
            },
            disabled: {
                default: false,
                type: Boolean
            },
            appendText: {
                default: ''
            },
            prependText: {
                default: ''
            },
            allowNegative: {
                default: true,
                type: Boolean
            }
		},
		data() {
			return {
			}
		},
		methods:{
			handlerChange(e){
                e = this.allowNegative ? util.checkInteger(e) : util.checkIntNum(e)
				this.$emit('input',e)
			},
		}
	}
</script>
